export function isStaircaseDefinitionId(id: string): boolean {
  return id === "straightStair" || id === "lShapedStair" || id === "uShapedStair";
}
